import { Drawer as ADrawer } from 'antd';
import styled from 'styled-components';

const StyledDrawer = styled(ADrawer)`
  z-index: 1300 !important;

  .ant-drawer-content-wrapper {
    max-width: 100%;
  }

  .ant-drawer-header {
    border: none;
    padding: 50px 30px;
  }

  .ant-drawer-title {
    color: var(--dark);
    font-size: 22px;
    font-weight: bold;
  }

  .ant-drawer-body {
    padding: 0;
    height: 100%;
    background-color: var(--very-light-bg);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .ant-drawer-close {
    top: 30px;
    right: 10px;
    color: var(--ultramarine-blue);
  }
`;

export default StyledDrawer;
